export const MANAGE_CUSTOM_CATEGORIES_FORM_FIELD_NAMES = {
  CATEGORIES: 'categories',
} as const;
